import { Link as RouterLink } from 'react-router';
import { PropsWithChildren } from 'react';
import styles from './Link.module.css';
import classNames from 'classnames';

type Props = PropsWithChildren & {
  underline?: boolean;
  target?: string;
  rel?: string;
  to: string;
};

export function Link({ children, underline, ...rest }: Props) {
  return (
    <RouterLink
      className={classNames(styles.link, {
        [styles.underline]: underline,
      })}
      {...rest}
    >
      {children}
    </RouterLink>
  );
}
